import api from "./axios";

export const getChatContactsApi = (params = {}) =>
  api.get("/chat/contacts", { params });

export const startNewConversationApi = (data) =>
  api.post("/chat/conversations/start", data);

export const getConversationByLeadApi = (leadId) =>
  api.get(`/chat/leads/${leadId}/conversation`);

export const markConversationReadApi = (conversationId) =>
  api.put(`/chat/conversations/${conversationId}/read`, null, { skipToast: true });

export const getMessagesApi = (conversationId, params = {}) =>
  api.get(`/chat/conversations/${conversationId}/messages`, { params });

export const sendMessageApi = (conversationId, data) =>
  api.post(`/chat/conversations/${conversationId}/messages`, data);

export const getTemplatesApi = () =>
  api.get("/chat/templates");

export const createTemplateApi = (data) =>
  api.post("/chat/templates", data);

export const sendTemplateApi = (conversationId, data) =>
  api.post(`/chat/conversations/${conversationId}/templates`, data);

/**
 * Upload chat media (image, audio, video) to Cloudinary
 * @param {File} file - File to upload
 * @returns {Promise} Upload result with Cloudinary URL
 */
export const uploadChatMediaApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post("/chat/upload/media", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
